import approvalConfiguration from "../../cbt/api/approvalConfiguration";
import Logger from "../../services/Logger";

export async function handleCbtManagerApproval(
  cbt,
  policyResolvedId,
  cbtConnectionData
) {
  const initialResult = { travellers: [], shouldDisplayGuests: false };

  const isCbtConnectionEnabled =
    cbtConnectionData &&
    cbtConnectionData.cbtApiUrl &&
    cbtConnectionData.customerUsername &&
    cbtConnectionData.cbtToken;

  if (!isCbtConnectionEnabled) {
    return initialResult;
  }

  if (!cbt.policyResolvedId && !policyResolvedId) {
    Logger.error("Manager Approval missing policy resolved ID", {
      cbt,
      cbtConnectionData,
    });
    return initialResult;
  }

  const travellers =
    cbt.passengersForm?.travellers && cbt.usersCache
      ? cbt.passengersForm.travellers.map((id) => {
          const { Id, FirstName, LastName, Email } = cbt.usersCache[id];
          return { Id, FirstName, LastName, Email };
        })
      : [];

  const config = await approvalConfiguration({
    cbtConnectionData,
    policyResolveId: cbt.policyResolvedId || policyResolvedId,
  });

  const managedTravellers = config.reduce((acc, curr) => {
    if (curr.Type === "Traveller" && curr.ShouldDisplaySelector) {
      return {
        travellers: [
          ...acc.travellers,
          {
            TravellerId: curr.TravellerId,
            Email: travellers.find(({ Id }) => Id === curr.TravellerId).Email,
          },
        ],
        shouldDisplayGuests: acc.shouldDisplayGuests,
      };
    }
    if (curr.Type === "Guest" && curr.ShouldDisplaySelector) {
      return {
        travellers: acc.travellers,
        shouldDisplayGuests: true,
      };
    }
    return acc;
  }, initialResult);

  return managedTravellers;
}
